
<template>
  <transition name="fade" @enter="enter" appear>
    <div v-if="this.scenes.start">
      <div class="scene-wrap loading-wrap">
        <!-- <img
          class="start-btn"
          @click="StartBtnFunc"
          :src="`images/ui/start-btn-${this.lang}.png`"
          alt=""
        /> -->
         <img
          class="start-btn"
          @click="StartBtnFunc"
          :src="`images/ui/start-btn-${this.lang}.png`"
          alt=""
        />
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: "Start",
  props: [ "scenes","lang"],
  created() {
  },
  methods: {
    enter() {},
    StartBtnFunc() {
      this.emitter.emit("hide-start");
      this.emitter.emit("show-opening");
      var audio = document.querySelector(".audio");
      audio.play();
    },
  },
};
</script>

